<template>
  <q-layout view="lHh Lpr lFf" class="bg-grey-2">
    <!-- Header Principal -->
    <q-header elevated class="bg-primary text-white">
      <q-toolbar>
        <q-btn
          flat
          dense
          round
          icon="menu"
          aria-label="Menu"
          @click="leftDrawerOpen = !leftDrawerOpen"
        />

        <q-avatar square size="32px" class="q-ml-sm">
          <img src="../../assets/logo.svg" alt="Logo" />
        </q-avatar>

        <q-toolbar-title class="text-weight-bold flex items-center">
          <span class="q-ml-xs text-subtitle1">Corporación Aveo</span>
          <q-badge color="secondary" class="q-ml-sm text-caption">Sigma</q-badge>
        </q-toolbar-title>

        <q-space />

        <!-- Menu Usuario -->
        <div class="flex items-center q-gutter-sm">
          <q-btn flat no-caps class="flex items-center">
            <q-avatar size="28px" class="bg-blue-3 text-primary text-weight-bold q-mr-xs">
              {{ (usuario || 'U').charAt(0).toUpperCase() }}
            </q-avatar>
            <span class="gt-xs text-weight-medium">{{ usuario || 'Usuario' }}</span>
            <q-icon name="arrow_drop_down" />

            <q-menu auto-close>
              <q-list style="min-width: 150px">
                <q-item clickable @click="$router.push('/aveo/configuracion')">
                  <q-item-section avatar><q-icon name="settings" /></q-item-section>
                  <q-item-section>Configuración</q-item-section>
                </q-item>
                <q-separator />
                <q-item clickable @click="Salir">
                  <q-item-section avatar><q-icon name="exit_to_app" color="negative" /></q-item-section>
                  <q-item-section class="text-negative text-weight-bold">Cerrar Sesión</q-item-section>
                </q-item>
              </q-list>
            </q-menu>
          </q-btn>
        </div>
      </q-toolbar>
    </q-header>

    <!-- Sidebar Drawer Left -->
    <q-drawer
      v-model="leftDrawerOpen"
      show-if-above
      bordered
      content-class="bg-grey-1"
      :width="260"
    >
      <q-scroll-area class="fit">
        <q-list padding class="text-grey-8">
          <q-item-label header class="text-weight-bold text-uppercase text-grey-6">
            Navegación Principal
          </q-item-label>

          <!-- Inicio -->
          <q-item clickable v-ripple to="/aveo/Dashboard" active-class="bg-blue-1 text-primary text-weight-bold">
            <q-item-section avatar><q-icon name="dashboard" color="primary" /></q-item-section>
            <q-item-section>Dashboard</q-item-section>
          </q-item>

          <q-separator class="q-my-sm" />

          <template v-if="tipo == 'admin' || true">
            <!-- Licencias (Nueva Opción de Gestión) -->
            <q-expansion-item
              icon="verified_user"
              label="Licencias y Versiones"
              header-class="text-weight-bold"
              group="menu"
              default-opened
            >
              <q-list class="q-pl-md">
                <q-item clickable v-ripple to="/aveo/Licencia/Lista" active-class="text-primary text-weight-bold">
                  <q-item-section avatar><q-icon name="key" size="xs" /></q-item-section>
                  <q-item-section>Lista de Licencias</q-item-section>
                </q-item>
                <q-item clickable v-ripple to="/aveo/Versiones/Lista" active-class="text-primary text-weight-bold">
                  <q-item-section avatar><q-icon name="system_update" size="xs" /></q-item-section>
                  <q-item-section>Versiones SISCORP</q-item-section>
                </q-item>
              </q-list>
            </q-expansion-item>

            <!-- Empresas -->
            <q-expansion-item
              icon="business"
              label="Empresas"
              header-class="text-weight-bold"
              group="menu"
            >
              <q-list class="q-pl-md">
                <q-item clickable v-ripple to="/aveo/Empresa/Lista" active-class="text-primary text-weight-bold">
                  <q-item-section avatar><q-icon name="list" size="xs" /></q-item-section>
                  <q-item-section>Lista de Empresas</q-item-section>
                </q-item>
                <q-item clickable v-ripple to="/aveo/Empresa/Nuevo" active-class="text-primary text-weight-bold">
                  <q-item-section avatar><q-icon name="add_business" size="xs" /></q-item-section>
                  <q-item-section>Nueva Empresa</q-item-section>
                </q-item>
                <q-item clickable v-ripple to="/aveo/Empresa/VencimientoLista" active-class="text-primary text-weight-bold">
                  <q-item-section avatar><q-icon name="event" size="xs" /></q-item-section>
                  <q-item-section>Vencimientos</q-item-section>
                </q-item>
              </q-list>
            </q-expansion-item>

            <!-- Usuarios -->
            <q-expansion-item
              icon="people"
              label="Usuarios"
              header-class="text-weight-bold"
              group="menu"
            >
              <q-list class="q-pl-md">
                <q-item clickable v-ripple to="/aveo/ListaUsuarios" active-class="text-primary text-weight-bold">
                  <q-item-section avatar><q-icon name="format_list_bulleted" size="xs" /></q-item-section>
                  <q-item-section>Lista de Usuarios</q-item-section>
                </q-item>
              </q-list>
            </q-expansion-item>

            <!-- Planes -->
            <q-expansion-item
              icon="subscriptions"
              label="Planes"
              header-class="text-weight-bold"
              group="menu"
            >
              <q-list class="q-pl-md">
                <q-item clickable v-ripple to="/aveo/Plan/ListaPlanes" active-class="text-primary text-weight-bold">
                  <q-item-section avatar><q-icon name="view_list" size="xs" /></q-item-section>
                  <q-item-section>Lista de Planes</q-item-section>
                </q-item>
                <q-item clickable v-ripple to="/aveo/Plan/PlanesAgregar" active-class="text-primary text-weight-bold">
                  <q-item-section avatar><q-icon name="post_add" size="xs" /></q-item-section>
                  <q-item-section>Nuevo Plan</q-item-section>
                </q-item>
              </q-list>
            </q-expansion-item>

            <!-- Servicios -->
            <q-expansion-item
              icon="build"
              label="Servicios"
              header-class="text-weight-bold"
              group="menu"
            >
              <q-list class="q-pl-md">
                <q-item clickable v-ripple to="/aveo/Servicio/Lista" active-class="text-primary text-weight-bold">
                  <q-item-section avatar><q-icon name="handyman" size="xs" /></q-item-section>
                  <q-item-section>Lista de Servicios</q-item-section>
                </q-item>
              </q-list>
            </q-expansion-item>

            <!-- Tipo de Cambio -->
            <q-expansion-item
              icon="currency_exchange"
              label="Tipo de Cambio"
              header-class="text-weight-bold"
              group="menu"
            >
              <q-list class="q-pl-md">
                <q-item clickable v-ripple to="/aveo/Cambio/Lista" active-class="text-primary text-weight-bold">
                  <q-item-section avatar><q-icon name="attach_money" size="xs" /></q-item-section>
                  <q-item-section>Lista de Cambio</q-item-section>
                </q-item>
              </q-list>
            </q-expansion-item>

            <!-- Sujetos Sin Capacidad Operativa (SSCO) -->
            <q-item clickable v-ripple to="/aveo/SSCO" active-class="bg-blue-1 text-primary text-weight-bold">
              <q-item-section avatar><q-icon name="gavel" color="primary" /></q-item-section>
              <q-item-section>Sujetos Sin Capacidad Operativa</q-item-section>
            </q-item>

            <!-- Configuración -->
            <q-item clickable v-ripple to="/aveo/configuracion" active-class="bg-blue-1 text-primary text-weight-bold">
              <q-item-section avatar><q-icon name="settings" color="primary" /></q-item-section>
              <q-item-section>Configuración</q-item-section>
            </q-item>
          </template>

          <q-separator class="q-my-md" />

          <!-- Salir -->
          <q-item clickable v-ripple @click="Salir" class="text-negative">
            <q-item-section avatar><q-icon name="logout" color="negative" /></q-item-section>
            <q-item-section class="text-weight-bold">Cerrar Sesión</q-item-section>
          </q-item>
        </q-list>
      </q-scroll-area>
    </q-drawer>

    <!-- Page Content Container -->
    <q-page-container>
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </q-page-container>
  </q-layout>
</template>

<script>
export default {
  name: "Layout",
  data() {
    return {
      leftDrawerOpen: true,
    };
  },
  computed: {
    tipo() {
      return this.$store.state.tipo;
    },
    usuario() {
      return this.$store.state.usuario || "Usuario";
    },
  },
  methods: {
    Salir() {
      window.localStorage.removeItem("authenticated");
      this.$store.state.usuario = "";
      this.$store.state.tipo = "";
      this.$router.push("/login");
    },
  },
};
</script>
